import * as React from 'react';
import {
    getDateTimeFromIndex,
    getSlotIndex
} from '../components/TimelineCalendar/timelineCalendarHelperFuncitons';
import { Photographer } from '../BookingsCalendarTypes';
import ICalendarItem from '../../../calendar/Types';

type useUpdateBookingInfoProps = {
    businessHours: Date[];
    bookingInfo: Partial<ICalendarItem>;
    fiveMinuteTimeSlots: Date[];
    onChangePhotographer: (newPhotographer: Photographer) => void;
    onChangeBookingInfo: (bookingInfo: Partial<ICalendarItem>) => void;
};

function useUpdateBookingInfo({
    businessHours,
    bookingInfo,
    fiveMinuteTimeSlots,
    onChangeBookingInfo,
    onChangePhotographer
}: useUpdateBookingInfoProps) {
    const [movedStartIndex, setMovedStartIndex] = React.useState<number>(null);

    function lengthOfBooking() {
        const startIndex =
            bookingInfo && Math.round(getSlotIndex(businessHours[0], new Date(bookingInfo.start)));
        const endIndex = Math.round(
            bookingInfo && getSlotIndex(businessHours[0], new Date(bookingInfo.end))
        );
        return endIndex - startIndex;
    }

    const onDropUpdateBookingInfo = (
        newPhotographer: Photographer,
        newStartIndex: number,
        isResized: boolean,
        newEndIndex?: number
    ) => {
        if (!bookingInfo) {
            console.warn(
                '[useUpdateBookingInfo.tsx:43] Changed when no booking information was present. Might want to look into it.',
                {
                    newPhotographer,
                    newStartIndex,
                    isResized,
                    newEndIndex
                }
            );
            return;
        }

        if (isResized) {
            let newEndTime = fiveMinuteTimeSlots.find((slot, index) => index === newEndIndex - 1);

            onChangePhotographer(newPhotographer);

            onChangeBookingInfo({ ...bookingInfo, end: newEndTime });
        }

        if (!isResized) {
            let newStartTime = getDateTimeFromIndex(newStartIndex - 1, fiveMinuteTimeSlots);
            let newEndTime = getDateTimeFromIndex(
                newStartIndex - 1 + lengthOfBooking(),
                fiveMinuteTimeSlots
            );

            setMovedStartIndex(newStartIndex);
            onChangePhotographer(newPhotographer);

            let newBookingInfo = {
                userId: newPhotographer.id,
                start: newStartTime,
                end: newEndTime
            };

            onChangeBookingInfo(newBookingInfo);
        }
    };

    return {
        movedStartIndex,
        onDropUpdateBookingInfo,
        lengthOfBooking
    };
}

export default useUpdateBookingInfo;
